import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Stack } from '@mui/material';
import { ArrowDown, ArrowUp } from 'lucide-react';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { OrderConditionNavigatorViewProps } from './orderConditionNavigator.types';

const NAVIGATION_BUTTON_SIZE = 32;
const NAVIGATION_BUTTON_PADDING = 1;

const OrderConditionNavigatorView = ({
  previous,
  next,
  children,
}: OrderConditionNavigatorViewProps) => {
  const { translate } = useTranslation();

  const canNavigate = !previous.isDisabled || !next.isDisabled;
  const nextLabel = translate(LangEnum.ORDER_CONDITION_NAVIGATE_NEXT);
  const previousLabel = translate(LangEnum.ORDER_CONDITION_NAVIGATE_PREVIOUS);

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1, minHeight: NAVIGATION_BUTTON_SIZE }}>
      {canNavigate && (
        <Stack direction="row" sx={{ alignItems: 'center', flexShrink: 0 }}>
          <Tooltip TooltipContent={nextLabel} tabIndex={-1}>
            <IconButton
              icon={ArrowDown}
              disabled={next.isDisabled}
              ariaLabel={nextLabel}
              testId={OrderConditionsTestIds.NAVIGATE_NEXT}
              onClick={next.onClick}
            />
          </Tooltip>

          <Tooltip TooltipContent={previousLabel} tabIndex={-1}>
            <IconButton
              icon={ArrowUp}
              disabled={previous.isDisabled}
              ariaLabel={previousLabel}
              testId={OrderConditionsTestIds.NAVIGATE_PREVIOUS}
              onClick={previous.onClick}
            />
          </Tooltip>
        </Stack>
      )}

      <Stack
        sx={{
          flex: 1,
          minWidth: 0,
          alignItems: 'flex-start',
          paddingInline: canNavigate ? 0 : NAVIGATION_BUTTON_PADDING,
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default OrderConditionNavigatorView;
